import { List } from 'immutable';
import Workflow, { Workflows } from 'records/Workflow';
import BaseList from 'records/BaseList';

import { REHYDRATE } from 'redux-persist/constants';
import {
  WORKFLOWS_ASYNC_ACTION_START,
  WORKFLOWS_ASYNC_ACTION_ERROR,
  WORKFLOWS_UPDATE_ASYNC_ACTION_SUCCESS,
  WORKFLOWS_COMPLETE_PROCESSS_STEP_ASYNC_SUCCESS,
  WORKFLOWS_UPDATE_ACTION_ERROR,
  WORKFLOWS_RESET_STATE,
} from 'actions/workflows';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [WORKFLOWS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [WORKFLOWS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [WORKFLOWS_UPDATE_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const workflowsData = Workflows(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: workflowsData,
    });
  },
  [WORKFLOWS_COMPLETE_PROCESSS_STEP_ASYNC_SUCCESS]: (state, action) => {
    if (state.data) {
      const workflowsData = Workflow.updateWorkflowsProcessSteps(state.data, action.data);
      return state.merge({
        loading: false,
        errorMessage: null,
        data: workflowsData,
      });
    }
    return state;
  },
  [WORKFLOWS_UPDATE_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
      data: new List(),
    });
  },
  [WORKFLOWS_RESET_STATE]: () => {
    return initialState;
  },
  [REHYDRATE]: (state, action) => {
    const workflowsPayload = action.payload.workflows;
    if (workflowsPayload) {
      const workflowsData = Workflows(workflowsPayload.data);
      return new BaseList({
        loading: workflowsPayload.loading,
        errorMessage: workflowsPayload.errorMessage,
        data: workflowsData,
      });
    }
    return state;
  },
};

export default function workflows(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
